<template>
	<b-container class="bv-example-row">
		<b-row>
			<b-col>
				<div class="article" v-if="title" @touchstart="touchstart" @touchmove="touchmove">
					<div class="title">{{ title }}</div>
					<div v-if="link != '#'" class="link">
						<b-link :href="link">{{ author + '@' + site }}</b-link>
					</div>
					<div class="content" v-html="content" @dblclick="like"></div>
				</div>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
import axios from 'axios';

export default {
  name: "Read",
  data() {
    return {
      random: false, // 是否是随机模式，true为随机模式，false为顺序模式
      id: '',
      title: '',
      author: '',
      site: '',
      content: '',
      link: '#',
      changing: false
    }
  },
  created() {
    window.console.log('本页面改为使用axios')

    // 使用挂载的第三方库
    const createDate = this.$moment(this.createTime).format('YYYY-MM-DD')
    window.console.log(createDate)
    
    if (this.$route.params && this.$route.params.id) {
      this.random = false
      this.id = this.$route.params.id * 1
      this.fetchArticle('https://qidafang.com/api/readArticle/' + this.id)
    } else {
      this.random = true
      let url = 'https://qidafang.com/api/randomArticle'
      this.fetchArticle(url)
    }
  },
  methods: {
    fetchArticle(url) {
      axios.get(url)
        .then(response => {
          let json = response.data;
          this.id = json.id * 1
          this.title = json.title
          this.author = json.author
          this.site = json.site
          this.content = json.text
          this.link = json.link

          this.changing = false
          document.body.scrollTop = document.documentElement.scrollTop = 0
        })
        .catch(error => console.error(error));
    },
    // Other methods here...
    like() {
      axios.post('https://qidafang.com/api/story/friendArticles/love/' + this.id)
        .then(response => {
          let json = response.data;
          if (json.code == 'success') {
            this.$bvToast.toast(json.data, {
              title: '提示',
              toaster: 'b-toaster-bottom-center',
              autoHideDelay: 5000,
              noCloseButton: true
            })
          } else {
            this.$bvToast.toast(json.data, {
              title: '提示',
              toaster: 'b-toaster-bottom-center',
              autoHideDelay: 5000,
              noCloseButton: true
            })
          }
        })
        .catch(error => window.console.error(error));
    }
  }
};
</script>

<style scoped>
	html {
		touch-action: none;
	}

	.title {
		margin-top: 15px;
		font-size: 120%;
		font-weight: 600;
	}

	.link {
		margin-top: 15px;
	}

	.content {
		margin-top: 30px;
	}
</style>
